import { SignIn } from "@clerk/clerk-react";

export default function LoginPage() {
  return (
    <div className="grid h-full place-items-center px-6 py-10">
      <div className="w-full max-w-sm space-y-6">
        <div className="text-center">
          <h1 className="text-3xl font-semibold">Cogi</h1>
          <p className="mt-1 text-sm text-neutral-500">Your growth coach</p>
        </div>
        <SignIn
          routing="hash"
          appearance={{
            elements: {
              rootBox: "w-full",
              card: "shadow-none border border-neutral-200 rounded-2xl",
            },
          }}
        />
      </div>
    </div>
  );
}
